// extracted by mini-css-extract-plugin
export var button = "_mx-0";